export const useStyles = () => {
  return {
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: '16px',
      '@media (max-width: 1023px)': {
        paddingTop: '12px',
      },
      '@media (max-width: 767px)': {
        paddingTop: '8px',
      },
      '@media (max-width: 480px)': {
        paddingTop: '4px',
      },
    },

    ratingButtonsContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '16px',
      mb: 2,
      flexWrap: 'wrap',
      '@media (max-width: 1023px)': {
        gap: '12px',
        mb: 1.5,
      },
      '@media (max-width: 767px)': {
        gap: '10px',
        mb: 1,
      },
      '@media (max-width: 480px)': {
        gap: '8px',
        mb: 0.5,
      },
    },
    ratingButton: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      border: '1px solid #FFF',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#FFF',
      fontFamily: 'Noto Sans',
      fontSize: '18px',
      fontWeight: '600',
      minWidth: 'auto',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: '1px solid #FFF',
      },
      transition: 'all 0.2s ease-in-out',
      '@media (max-width: 1023px)': {
        width: '40px',
        height: '40px',
        fontSize: '16px',
      },
      '@media (max-width: 767px)': {
        width: '36px',
        height: '36px',
        fontSize: '14px',
      },
      '@media (max-width: 480px)': {
        width: '32px',
        height: '32px',
        fontSize: '12px',
      },
    },
    ratingButtonSelected: {
      backgroundColor: '#FFF',
      color: '#000',
      '&:hover': {
        backgroundColor: '#FFF',
      },
    },
    selectedValueContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '32px',
      marginTop: '8px',
      '@media (max-width: 1023px)': {
        minHeight: '28px',
        marginTop: '6px',
      },
      '@media (max-width: 767px)': {
        minHeight: '24px',
        marginTop: '4px',
      },
      '@media (max-width: 480px)': {
        minHeight: '20px',
        marginTop: '4px',
      },
    },
    selectedValueText: {
      color: '#FFF',
      fontFamily: 'Noto Sans',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '140%',
      textAlign: 'center',
      '@media (max-width: 1023px)': {
        fontSize: '14px',
      },
      '@media (max-width: 767px)': {
        fontSize: '13px',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
  };
};
